import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { IonInfiniteScroll, ModalController } from '@ionic/angular';
import { MissionsService } from 'src/app/services/missions.service';
import { ToolsService } from 'src/app/services/tools.service';
import { ProductSlidesPage } from '../product-slides/product-slides.page';
import { AnalyticsService } from 'src/app/services/analytics.service';
export class ModalUserAnswersQuestionsPage {
    constructor(modalController, missionsService, toolsService, analyticsService) {
        this.modalController = modalController;
        this.missionsService = missionsService;
        this.toolsService = toolsService;
        this.analyticsService = analyticsService;
        this.missionAnswers = [];
        this.page = 2;
        this.objects = 3;
        this.analyticsService.AnalyticsServiceModalView('user-answers-questions');
    }
    ngOnInit() {
    }
    loadUserAnswers(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let statesInSpanish = {
                'IN_PROGRESS': 'En progreso',
                'SENT': 'Enviado',
                'APPROVED': 'Aprobado',
                'FINISHED': 'Completado',
                'REJECTED': 'Rechazado',
                'PRE_COMPLETED': "Pre-Aprobada"
            };
            try {
                let answers = [];
                let responses = yield this.missionsService.getMissionAnswers(this.missionId, this.page, this.objects);
                let questions = yield this.missionsService.getMissionQuestions(this.missionId);
                for (let response of responses) {
                    for (let answer of response.answers) {
                        response.spanish_state = statesInSpanish[response.state];
                        let question = questions.find(item => item.id == answer.question);
                        if (question)
                            answer.question = question.label;
                        if (!answer.body)
                            answer.body = 'No';
                        if (answer.body === true)
                            answer.body = 'Sí';
                        if (typeof answer.body == 'string') {
                            if (answer.body.match(/https:\/\//)) {
                                answer.isUrl = true;
                                if (answer.body.indexOf('/images/') > -1)
                                    answer.isImage = true;
                                else if (answer.body.indexOf('/files/') > -1)
                                    answer.isFile = true;
                            }
                            if (answer.body.match(/20..-..-..T..:..:/g))
                                answer.body = this.toolsService.formatDate(answer.body);
                        }
                        if (typeof answer.body == 'object') {
                            answer.isObject = true;
                            answer.body = this.setSelectValue(answer.body);
                        }
                    }
                    answers.push(response);
                }
                const uniqueAnswers = answers.filter(answer => !this.missionAnswers.some(existingAnswer => existingAnswer.id === answer.id));
                if (event)
                    event.target.complete();
                this.missionAnswers = this.missionAnswers.concat(uniqueAnswers);
                this.page++;
            }
            catch (error) {
                this.toolsService.showErrorToast();
                console.error("[MISSION-DETAIL-PAGE-ANSWERS] loadUserAnswers()", error);
            }
        });
    }
    setSelectValue(response) {
        if (response) {
            try {
                var result = "";
                for (let value of response) {
                    result = result + ", " + value.name;
                }
                return result.substr(2);
            }
            catch (error) {
                //console.log(response)
                return response.name;
            }
        }
    }
    closeModal() {
        this.modalController.dismiss();
    }
    openFileNewTab(url) {
        window.open(url);
    }
    presentProductSlidesModal(src) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let activeImage = { index: 0 };
            let image = [{ image: src }];
            const modal = yield this.modalController.create({
                component: ProductSlidesPage,
                cssClass: 'fullSizeModal',
                componentProps: {
                    productImages: image,
                    activeImage: activeImage
                }
            });
            return yield modal.present();
        });
    }
}
